import { render, staticRenderFns } from "./DiscoveryForm.vue?vue&type=template&id=6cacb0f1&scoped=true&"
import script from "./DiscoveryForm.vue?vue&type=script&lang=js&"
export * from "./DiscoveryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cacb0f1",
  null
  
)

export default component.exports